import { format, parseISO } from 'date-fns';
import {
  DailyNavReportSourceRow,
  DailyNavValidationCompany,
  FirmDailyNavDay,
} from 'pages/Intelligence/DailyNav/daily-nav.api.types';

export const formatWhen = (value?: string | null) => {
  if (!value) {
    return '';
  }
  try {
    return format(parseISO(value), 'MMM d, yyyy, h:mm a');
  } catch {
    return value;
  }
};

export const formatSftpDelivery = (day?: FirmDailyNavDay | null, isSent = false) => {
  const host = day?.ftp_host;
  if (isSent) {
    if (day?.ftp_delivered) {
      return host ? `SFTP delivered to ${host}` : 'SFTP delivered';
    }
    if (day?.ftp_configured) {
      return 'SFTP not delivered';
    }
    return 'SFTP not delivered (not configured)';
  }
  if (day?.ftp_configured) {
    return host ? `SFTP will deliver to ${host}` : 'SFTP configured';
  }
  return 'SFTP not configured';
};

export const formatEmailDelivery = (
  day?: FirmDailyNavDay | null,
  recipients: string[] = [],
  isSent = false
) => {
  if (isSent) {
    if (day?.email_delivered) {
      return recipients.length ? `Email delivered to ${recipients.join(', ')}` : 'Email delivered';
    }
    if (recipients.length) {
      return 'Email not delivered';
    }
    return 'Email not delivered (no recipients)';
  }
  return recipients.length
    ? `Email will send to ${recipients.join(', ')}`
    : 'Email not configured';
};

export const formatPrice = (value?: string | null, currency?: string | null) => {
  if (!value) {
    return '—';
  }
  const amount = Number(value);
  if (Number.isNaN(amount)) {
    return value;
  }
  return amount.toLocaleString('en-US', {
    style: 'currency',
    currency: currency || 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatDate = (value?: string | null) => {
  if (!value) {
    return '—';
  }
  try {
    return format(parseISO(value), 'MMM d, yyyy');
  } catch {
    return value;
  }
};

export const formatFailedCompany = (company: DailyNavValidationCompany, rows: DailyNavReportSourceRow[]) => {
  const row = rows.find(reportRow => reportRow.company_id === company.company_id);
  if (company.cause === 'carry_forward_mismatch' && row?.valuation_price_per_share) {
    return `${company.company_name} (today ${formatPrice(row.valuation_price_per_share, row.currency)})`;
  }
  if (company.cause === 'triggered_incomplete') {
    return `${company.company_name} (review incomplete)`;
  }
  if (company.cause === 'started_incomplete') {
    return `${company.company_name} (in progress)`;
  }
  if (company.cause === 'missing_mark') {
    return `${company.company_name} (no mark)`;
  }
  return company.company_name;
};
